import { postAction } from './postAction'
import type { RebuildInventoryPayload } from '../../types'

export async function rebuildInventory(
  token: string,
  body: RebuildInventoryPayload,
): Promise<string> {
  const result = await postAction('/v1/act/build/inventory', token, body)
  return result.message ?? 'Rebuild request accepted.'
}
